import { render, staticRenderFns } from "./UploadFileFormItem.vue?vue&type=template&id=362d6fbc&scoped=true&"
import script from "./UploadFileFormItem.vue?vue&type=script&lang=js&"
export * from "./UploadFileFormItem.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileFormItem.vue?vue&type=style&index=0&id=362d6fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362d6fbc",
  null
  
)

export default component.exports